import React from 'react';
import {inject, observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ChangePasswordTopBar} from '../change-password-top-bar/index';
import {ChangePasswordContent} from '../change-password-content/index';
import {IChangePasswordStore} from '../../change-password.stores';
import {IChangePasswordController} from '../../change-password.controller';
import {ILocalizationService} from '../../../../services/LocalizationService';

import './styles.scss';

interface ChangePasswordLayoutProps {
    controller: IChangePasswordController;
    accountLogo: string;
    localizationService: ILocalizationService;
}

const mapStoresToProps = (stores: {changePasswordStore?: IChangePasswordStore}): ChangePasswordLayoutProps => ({
    controller: stores.changePasswordStore!.changePasswordController,
    accountLogo: stores.changePasswordStore!.accountLogo,
    localizationService: stores.changePasswordStore!.localizationService
});

@inject(mapStoresToProps)
@observer
export class ChangePasswordLayoutComponent extends TechseeBaseComponent<ChangePasswordLayoutProps> {
    renderInternal() {
        this.addCssClass('change-password-root-layout');
        this.addCssClass('use-common-styles');

        const {controller, accountLogo = '/img/new-logo.png', localizationService} = this.props;

        return (
            <div className={this.renderCssClasses()}>
                <ChangePasswordTopBar
                    controller={controller}
                    accountLogo={accountLogo}
                    localizationService={localizationService}
                />
                <main className='change-password-main-content'>
                    <ChangePasswordContent controller={controller} />
                </main>
            </div>
        );
    }
}

export default ChangePasswordLayoutComponent;
